// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1SrE5","footer":"ModalError_footer__wOOZz"};